export default __webpack_public_path__ + "static/media/unauthorized.1df25288.png";